import { isEmpty } from 'lodash';

type ConvertedObject = Record<string, unknown>;

export interface ConvertSettings {
    useParentPath?: boolean;
}

const convertObjectToPaths = <T extends ConvertedObject, K extends Record<keyof T, ConvertSettings>>(
    obj: T,
    settings: K = {} as K,
    parentKey = ''
): string[] => {
    let paths: string[] = [];

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (key in settings && settings[key].useParentPath) {
                paths.push(key);
                // eslint-disable-next-line no-continue
                continue;
            }

            const value = obj[key];
            const isArray = Array.isArray(obj);

            let path;
            if (parentKey) {
                path = isArray ? `${parentKey}[${key}]` : `${parentKey}.${key}`;
                path = isArray && typeof value !== 'object' ? `${parentKey}` : path;
            } else {
                path = key.toString();
            }
            if (typeof value === 'object' && isEmpty(value)) {
                paths.push(path);
            } else if (typeof value === 'object' && value !== null) {
                paths = paths.concat(convertObjectToPaths(value as ConvertedObject, settings, path));
            } else {
                paths.push(path);
            }
        }
    }

    return [...new Set(paths)];
};

export default convertObjectToPaths;
